import { useState, type ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { VorherigeSeite } from './seitenverlauf';

interface Verlauf {
  aktuell: string;
  vorher: string | null;
}

/**
 * Merkt sich, wo der Nutzer zuletzt war — Grundlage des Rückwegs in der
 * Hülle. Die Regeln dazu stehen in `seitenverlauf.ts`.
 */
export function SeitenverlaufProvider({ children }: { children: ReactNode }) {
  const { pathname, search } = useLocation();
  const aktuell = pathname + search;
  const [verlauf, setVerlauf] = useState<Verlauf>(() => ({ aktuell, vorher: null }));

  // Zustandsanpassung während des Renderns — der von React vorgesehene Weg,
  // abgeleiteten Zustand nachzuziehen. Ein `useEffect` täte es erst nach dem
  // Anzeigen, der Rückweg würde bei jedem Seitenwechsel kurz aufblitzen.
  if (verlauf.aktuell !== aktuell) {
    setVerlauf({ aktuell, vorher: verlauf.aktuell });
  }

  return <VorherigeSeite.Provider value={verlauf.vorher}>{children}</VorherigeSeite.Provider>;
}
